import { motion } from 'motion/react'
import React from 'react'
import styled from 'styled-components'

import type { FileItemProps } from '../types'

const Root = styled.div`
    position: relative;
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    overflow: hidden;
`

const StyledImage = styled(motion.img)`
    max-width: 100%;
    max-height: 100%;
    object-fit: contain;
    pointer-events: none;
    user-select: none;
`

export const WechatNativeImage = styled.img`
    max-width: 100%;
    max-height: 100%;
    object-fit: contain;
    pointer-events: auto;
    user-select: auto;
    -webkit-user-select: auto;
    -webkit-touch-callout: default;
    touch-action: auto;
`

export const ImageFile = ({ file, transform, dragOffset, enableWechatNativeMenu }: FileItemProps) => {
    const { rotate = 0, scale = 100 } = transform ?? {}
    const { x = 0, y = 0 } = dragOffset ?? {}

    // 计算当前缩放比例
    const currentScale = scale / 100

    if (enableWechatNativeMenu) {
        return (
            <Root style={{ overflow: 'visible' }}>
                <WechatNativeImage src={file.url} alt={file.name} />
            </Root>
        )
    }

    return (
        <Root>
            <StyledImage
                src={file.url}
                alt={file.name}
                draggable={false}
                animate={{
                    x,
                    y,
                    scale: currentScale,
                    rotate
                }}
                transition={{
                    scale: {
                        type: false
                    },
                    rotate: {
                        ease: 'easeInOut'
                    },
                    x: {
                        type: false
                    },
                    y: {
                        type: false
                    }
                }}
            />
        </Root>
    )
}
